import { Sparkles } from "lucide-react";

export default function StepReview({
  selectedPackage, selectedAddOns, addOns, date, timeSlot, form, total,
  payDeposit, setPayDeposit, deposit, error,
}) {
  return (
    <div data-testid="step-review">
      <h2 className="font-heading text-2xl tracking-tight mb-6">Review & confirm</h2>
      <div className="card-surface p-8 grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <div className="eyebrow mb-2">Package</div>
          <div className="font-heading text-xl">{selectedPackage?.name}</div>
          <div className="text-sm text-muted2">{selectedPackage?.tagline}</div>

          <div className="eyebrow mb-2 mt-6">Add-ons</div>
          <div className="text-sm">
            {selectedAddOns.length === 0 ? (
              <div className="text-muted2">None</div>
            ) : (
              selectedAddOns.map((aid) => {
                const a = addOns.find((x) => x.id === aid);
                return <div key={aid} className="flex justify-between"><span>{a?.name}</span><span>${a?.price}</span></div>;
              })
            )}
          </div>

          <div className="eyebrow mb-2 mt-6">When</div>
          <div className="text-base">
            {date && date.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" })} · {timeSlot}
          </div>
        </div>

        <div>
          <div className="eyebrow mb-2">Customer</div>
          <div className="text-base">{form.name}</div>
          <div className="text-sm text-muted2">{form.email} · {form.phone}</div>

          <div className="eyebrow mb-2 mt-6">Service address</div>
          <div className="text-base">{form.address}</div>
          <div className="text-sm text-muted2">{form.city}, {form.state} {form.zip_code}</div>

          {form.notes && (
            <>
              <div className="eyebrow mb-2 mt-6">Notes</div>
              <div className="text-sm text-muted2">{form.notes}</div>
            </>
          )}

          <div className="border-t border-black/10 mt-6 pt-4 flex justify-between items-baseline">
            <span className="eyebrow">Estimated total</span>
            <span className="font-heading text-3xl">${total}</span>
          </div>
          <p className="text-xs text-muted2 mt-2">Pay only after service. The estimated total may adjust based on actual vent count.</p>
        </div>
      </div>

      {/* Deposit toggle */}
      <div className="mt-6 card-surface p-6" data-testid="deposit-section">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="eyebrow mb-1">Optional · Recommended</div>
            <h3 className="font-heading text-xl tracking-tight">Add a ${deposit} refundable deposit</h3>
            <p className="text-sm text-muted2 mt-1 max-w-md">
              Lock in your slot and skip the phone call. The deposit is applied to your total — you'll only pay the remainder after service.
            </p>
          </div>
          <button
            type="button"
            role="switch"
            aria-checked={payDeposit}
            onClick={() => setPayDeposit(!payDeposit)}
            className={`shrink-0 inline-flex h-7 w-12 items-center rounded-full transition ${payDeposit ? "bg-forest" : "bg-black/15"}`}
            data-testid="deposit-toggle"
          >
            <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${payDeposit ? "translate-x-6" : "translate-x-1"}`} />
          </button>
        </div>
        {payDeposit && (
          <div className="mt-4 text-xs text-muted2 flex items-center gap-2">
            <Sparkles size={12} className="text-clay" />
            On confirm, you'll be redirected to a secure Stripe checkout to pay ${deposit}.
          </div>
        )}
      </div>
      {error && (
        <div className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 px-4 py-3 rounded-xl" data-testid="booking-error">
          {error}
        </div>
      )}
    </div>
  );
}
